<template>
    <v-app id="app">
        <app-navigation></app-navigation>

        <v-content transition="slide-x-transition">
            <router-view></router-view>
        </v-content>

        <confirm ref="confirm"></confirm>
        <alertm ref="alertm"></alertm>
    </v-app>
</template>

<script>

import styles from '@/app.css';

    import AppNavigation from '@/components/AppNavigation';
    import Confirm from '@/views/Confirm';
    import Alertm from '@/views/Alertm';
    import NoteBox from '@/components/NoteBox';

export default {
    name: 'App',
    components: {
        AppNavigation,
        Confirm,
        Alertm,
        'v-notebox':NoteBox
    },
    mounted: function () {
        window.rootconfirm = this.$refs.confirm.open;
        this.$root.$confirm = this.$refs.confirm.open;
        window.rootalertm = this.$refs.alertm.open;
        this.$root.alertm = this.$refs.alertm.open;
        window.onpopstate = function (event) {
            //alert("back: ");
            window.vuethis.$root.$router.push({ path: '/', name:"home"})
        };
    }
};
</script>

<style>

* {
    text-transform: none !important;
} 
.boxlabel {
  color: rgb(78, 78, 78);
  padding: 0px;
  margin: 2px;
  font-size: 80%;
}
.labelheading {
  color: rgb(190, 189, 189);
  padding: "pa-0";
  margin: "ma-0";
  font-size: 70%;
}
.fullbox {
  background-color:  rgb(240, 240, 240);
  padding: 1px;
  border-style: solid;
  border-width: thin;
}
.opentopbox {
  background-color:  rgb(240, 240, 240);
  padding: 1px;
  border-style: hidden solid solid solid;
  border-width: thin;
}
.opentopleftbox  {
  background-color:  rgb(240, 240, 240);
  padding: 1px;
  border-style: hidden solid solid hidden;
  border-width: thin;
}
.opentopleftrightbox  {
  background-color:  rgb(240, 240, 240);
  padding: 1px;
  border-style: hidden hidden solid hidden;
  border-width: thin;
}
</style>

